shadow$provide[105] = function(require,module,exports) {
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
var require$_DOT__DOT__SLASH_binder = require("../binder");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("bind", {install:function(three) {
  const globals = {three:three, window:window,};
  three.bind = require$_DOT__DOT__SLASH_binder.Binder.bind(three, globals);
  three.unbind = require$_DOT__DOT__SLASH_binder.Binder.unbind(three);
  three.bind("install:bind", this);
  three.bind("uninstall:unbind", this);
}, uninstall:function(three) {
  three.unbind(this);
  delete three.bind;
  delete three.unbind;
}, bind:function(event, three) {
  const plugin = event.plugin;
  const listen = plugin.listen;
  listen && listen.forEach(function(key) {
    three.bind(key, plugin);
  });
}, unbind:function(event, three) {
  three.unbind(event.plugin);
},});

};